/**
 * MasterVehicle
 */
export class MasterVehicle {

  /**
   * plate
   */
  plate: string;

  /**
   * model
   */
  model: string;

  /**
   * color
   */
  color: string;

  /**
   * type vehicle
   */
  typeVehicle: string;
  /**
   * allowed
   */
  allowed: number;
  /**
   * owner
   */
  owner: string;

  /**
   * card
   */
  card: string;

  /**
   * Barrier Profile
   */
  barrierProfile: number;

  /**
   * exact
   */
  exact: boolean;

  /**
   * last Entry
   */

  lastEntry: Date;

  /**
   * last Exit
   */
  lastExit: Date;
  /**
   * barrier Profile Name
   */
  barrierProfileName: string;
  /**
   * type Vehicle Name
   */
  vehicleTypeName: string;
  /**
   * Create instance from JSON
   *
   * @param json Object
   *
   * @returns MasterVehicle instance
   */
  static createFromJson(json: object): MasterVehicle {
    const self = new this();

    Object.keys(json).forEach(key => {
      self[key] = json[key];
    });

    return self;
  }



}
